import React, { memo } from 'react'
import { makeStyles, Typography } from 'transfix-ui/core'
import { IShipperApplicationContact } from 'types/graphqlTypes'
import { ConnectedPhoneNumber } from 'apps/marketplace/components/ConnectedPhoneNumber'
import { DISPLAY } from 'constants/display'

const PHONE_NUMBER_FORMAT = '###-###-####'
const phoneExtensionFormat = `, Ext ###`

const usePhoneStyles = makeStyles({
  phone: {
    whiteSpace: 'nowrap',
  },
})

type TContactPhoneProps = Pick<IShipperApplicationContact, 'phone' | 'phoneExtension'>

export const ContactPhone = memo<TContactPhoneProps>(({ phone, phoneExtension }) => {
  const classes = usePhoneStyles()

  if (!phone) return <Typography variant='body1'>{DISPLAY.empty}</Typography>
  return (
    <Typography variant='body1' className={classes.phone}>
      <ConnectedPhoneNumber
        phoneNumber={phone}
        phoneExtension={phoneExtension || ''}
        phoneNumberFormat={PHONE_NUMBER_FORMAT}
        phoneExtensionFormat={phoneExtensionFormat}
      />
    </Typography>
  )
})
